<template>
    <div>
        <el-form-item label="Tytuł"
                      :error="errors[addLanguageSuffix('label')]">
            <el-input v-model="item[addLanguageSuffix('label')]">
            </el-input>
        </el-form-item>
        <el-form-item label="Dodaj menu rozwijane"
                      v-if="allow_submenu">
            <el-checkbox label="Menu rozwijane"
                         @change="changeMenuItemType(item)"
                         :value="!(!!item.link)"/>
        </el-form-item>
        <link-component v-if="item.link"
                        v-model="item.link"
                        :errors="errors['link']"/>
        <div v-else>
            <el-collapse class="formset__list">
                <el-collapse-item v-for="subitem, i in item.submenu"
                                  class="formset__item formset__item--nested"
                                  :key="i">
                    <template slot="title">
                        <formset-header :label="`${subitem.label_pl || 'Nowy element podmenu'}`"
                                        :errors="checkForErrors(errors.submenu, [i])"
                                        :items.sync="item.submenu"
                                        :index="i"/>
                    </template>
                    <submenu-item
                            :itemKey="subitem.id || subitem.randomHash"
                            :errors="(errors.submenu && errors.submenu[i]) || {}"
                            :item.sync="subitem"/>
                </el-collapse-item>
            </el-collapse>
            <el-button @click="addSubmenuItem">Dodaj pozycję w submenu</el-button>
        </div>
    </div>
</template>
<script>
    import SubmenuItem from '@/views/Menus/SubmenuItem'

    export default {
        props: ["item", "errors", "allow_submenu"],
        components: {
            SubmenuItem
        },
        methods: {
            changeMenuItemType (item) {
                if (item.link) {
                    item.link = null
                    item.submenu = [
                        {}
                    ]
                } else {
                    item.submenu = null
                    item.link = {}
                }
                this.$forceUpdate()
            },
            addSubmenuItem () {
                const randomHash = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000
                const blankObject = {
                    randomHash: randomHash,
                    link: {}
                }
                if (!Array.isArray(this.item.submenu)) {
                    this.item.submenu = [blankObject]
                } else {
                    this.item.submenu.push(blankObject)
                }
                this.$forceUpdate()
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// MenuItem.vue?e468776a